import SignBlock from '../../components/bodyBlocks/signBlock/SignBlock'
import '../../index.css'

function Sign() {
  return (
    <div>
      <SignBlock/>
    </div>
   
  );
};

export default Sign
